import React from 'react'
import './nav.css'
import {BiHome} from 'react-icons/bi'
import {BiUserCircle} from 'react-icons/bi'
import {ImStack} from 'react-icons/im'
import {MdOutlineMedicalServices} from 'react-icons/md'
import {AiOutlineMessage} from 'react-icons/ai'
import {useState} from 'react'
import ReactTooltip from "react-tooltip";

const Nav = () => {

  // const checkbox = document.getElementById('checkbox');

  // checkbox.addEventListener('change', () => {
  //   document.body.classList.toggle('dark');
  // });

  const [activeNav, setActiveNav] = useState('#top');
  
  return (
      <nav>
        <a href="#top" onClick={() => setActiveNav('#top')} className={activeNav === '#top' ? 'active' : ''} data-tip data-for="homeTip" aria-label="Home"><BiHome/></a>
        <ReactTooltip id="homeTip" place="top" effect="solid">Home</ReactTooltip>

        <a href="#about" onClick={() => setActiveNav('#about')} className={activeNav === '#about' ? 'active' : ''} data-tip data-for="aboutTip" aria-label="About"><BiUserCircle/></a>
        <ReactTooltip id="aboutTip" place="top" effect="solid">About</ReactTooltip>

        <a href="#experience" onClick={() => setActiveNav('#experience')} className={activeNav === '#experience' ? 'active' : ''} data-tip data-for="experienceTip" aria-label="Experience"><ImStack/></a>
        <ReactTooltip id="experienceTip" place="top" effect="solid">Experience</ReactTooltip>

        <a href="#portfolio" onClick={() => setActiveNav('#portfolio')} className={activeNav === '#portfolio' ? 'active' : ''} data-tip data-for="portfolioTip" aria-label="Projects"><MdOutlineMedicalServices/></a>
        <ReactTooltip id="portfolioTip" place="top" effect="solid">Projects</ReactTooltip>

        <a href="#contact" onClick={() => setActiveNav('#contact')} className={activeNav === '#contact' ? 'active' : ''} data-tip data-for="contactTip" aria-label="Contact"><AiOutlineMessage/></a>
        <ReactTooltip id="contactTip" place="top" effect="solid">Contact</ReactTooltip>
      </nav>
    

  )
}

export default Nav
